<template>
  <v-menu offset-y v-model="open" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition"
    full-width max-width="290px" min-width="290px">
    <template #activator="{on}">
      <v-text-field v-model="Value" :label="label" persistent-hint prepend-icon="event" v-on="on" :name="text"
        :error-messages="error" clearable>
      </v-text-field>
    </template>
    <v-date-picker locale="zh-cn" v-model="Value" @input="open = false" :name="text" :error-messages="error" :type="type">
    </v-date-picker>

  </v-menu>
</template>

<style scoped>

</style>

<script>
  import GhDatePicker from "./ghDatePicker.ts";
  export default GhDatePicker;
</script>